import * as React from "react";
import { Link } from "gatsby";
import { EventAttributes, getEventAttributes } from "../../../utils/analytics";
import { grid } from "../../design-tokens/grid";
import { Fonts } from "../../design-tokens/fonts";
import { Colors } from "../../design-tokens/colors";
import { DarkTheme } from "../../design-tokens/media-queries";

interface LinkButtonProps {
  href: string;
  isCenter?: boolean;
  analytics: EventAttributes;
}

const LinkButton: React.FC<LinkButtonProps> = ({
  href,
  isCenter,
  analytics,
  children,
}) => {
  const content = (
    <Link
      to={href}
      css={{
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        WebkitAppearance: "none",
        minWidth: grid(19),
        height: grid(4),
        fontWeight: Fonts.Weight.SemiBold,
        color: Colors.Blue,
        backgroundColor: Colors.LightGrey,
        borderRadius: grid(4),

        ":hover": {
          textDecoration: "none",
        },

        [DarkTheme]: {
          color: Colors.DarkModeTextBlue,
          backgroundColor: Colors.DarkModeBlack,
        },
      }}
      {...getEventAttributes(analytics)}
    >
      {children}
    </Link>
  );

  return isCenter ? (
    <div css={{ display: "flex", justifyContent: "center" }}>{content}</div>
  ) : (
    content
  );
};

export default LinkButton;
